// src/redux/permissionsSlice.ts
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface AppModule {
  id: string;
  name: string;
  category?: string;
  // optional ui metadata
  navHref?: string;
  navIcon?: string; // optional string key or keep React component mapping in UI
}

interface PermissionsState {
  modules: AppModule[];
  // optionally, we can store roles or other config later
  // roles?: unknown[];
}

const initialState: PermissionsState = {
  // demo default empty — you can seed with MOCK_MODULES here
  modules: [],
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setModules(state, action: PayloadAction<AppModule[]>) {
      state.modules = action.payload;
    },
    clearModules(state) {
      state.modules = [];
    },
  },
});

export const { setModules, clearModules } = permissionsSlice.actions;
export default permissionsSlice.reducer;
